export const STATISTIC_FETCH_REQUEST = 'STATISTIC_FETCH_REQUEST';
export const STATISTIC_FETCH_SUCCESS = 'STATISTIC_FETCH_SUCCESS';
export const STATISTIC_FETCH_ERROR = 'STATISTIC_FETCH_ERROR';

export const STATISTIC_FILTER_RECIPIENT = 'STATISTIC_FILTER_RECIPIENT';
export const STATISTIC_FILTER_AUTHOR = 'STATISTIC_FILTER_AUTHOR';
export const STATISTIC_SORTING_DERECTION = 'STATISTIC_SORTING_DERECTION';
export const STATISTIC_FILTER_RECIPIENT_TEAM = 'STATISTIC_FILTER_RECIPIENT_TEAM';

export const BREAKPOINT_MD = 1350;
